































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {IShopCollection} from '@/models/IShopCollection';
import {getListShopCollection} from '@/services/ShopCollectionService';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {}
})
export default class ShopCollectionSelect extends Vue {
  @Prop() value!: number[];
  loading: boolean = true;
  shopCollections: IShopCollection[] = [];

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  onChange(value: IShopCollection[]) {
    this.$emit('input', value);
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.shopCollections = await getListShopCollection(this.organizationId, this.shopId);
    } finally {
      this.loading = false;
    }
  }
}
